import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface EditExperienceForCandidateResponse extends BackendResponse {}
export interface EditExperienceForCandidateParameters extends NextApiParams {
  experienceId: number;
  comment: string;
  level: number;
  from: string;
  to: string | null;
  customerId: number;
  candidateType: number;
  industryType: number;
  firm: string;
  position: string;
  references: string;
  hide: boolean;
}

export const editExperienceForCandidate = withNextApi<
  EditExperienceForCandidateResponse,
  EditExperienceForCandidateParameters
>("/cvp/CvpEditExperienceForCandidate");
